import React from 'react';
import { Helmet } from 'react-helmet';
import StickyAnchorNav from '../../components/ui/StickyAnchorNav';
import ScrollProgressIndicator from '../../components/ui/ScrollProgressIndicator';
import HeroSection from './components/HeroSection';
import ProblemSection from './components/ProblemSection';
import SolutionSection from './components/SolutionSection';
import StatsSection from './components/StatsSection';
import HowItWorksSection from './components/HowItWorksSection';
import SocialProofSection from './components/SocialProofSection';
import PricingSection from './components/PricingSection';
import FAQSection from './components/FAQSection';
import TrustBadgesSection from './components/TrustBadgesSection';
import ROICalculatorSection from './components/ROICalculatorSection';
import UseCaseSection from './components/UseCaseSection';
import FinalCTASection from './components/FinalCTASection';
import FooterSection from './components/FooterSection';

const LandingPage = () => {
  return (
    <>
      <Helmet>
        <title>LeadForge AI - Automate Lead Discovery, Outreach, and Booking — All in One Place</title>
      </Helmet>

      <div className="min-h-screen bg-background text-foreground">
        {/* Navigation & Progress */}
        <StickyAnchorNav />
        <ScrollProgressIndicator />

        {/* Page Sections */}
        <main>
          <HeroSection />
          <ProblemSection />
          <SolutionSection />
          <StatsSection />
          <HowItWorksSection />
          <PricingSection />
          <FAQSection />
          <UseCaseSection />
          <FinalCTASection />
        </main>

        {/* Footer */}
        <FooterSection />
      </div>
    </>
  );
};

export default LandingPage;